import { defineMessages } from 'react-intl';

export default defineMessages({
  addTitle: {
    id: 'simulated.contentmap.abilitymodal.addTitle',
    defaultMessage: 'ADD NEW ABILITY',
  },
  editTitle: {
    id: 'simulated.contentmap.abilitymodal.editTitle',
    defaultMessage: 'EDIT ABILITY',
  },
  approveTitle: {
    id: 'simulated.contentmap.abilitymodal.approveTitle',
    defaultMessage: 'APPROVE ABILITY',
  },
  reproveTitle: {
    id: 'simulated.contentmap.abilitymodal.reproveTitle',
    defaultMessage: 'REPROVE ABILITY',
  },
  viewTitle: {
    id: 'simulated.contentmap.abilitymodal.viewTitle',
    defaultMessage: 'VIEW ABILITY',
  },
  approve: {
    id: 'simulated.contentmap.abilitymodal.approve',
    defaultMessage: 'Approve',
  },
  close: {
    id: 'simulated.contentmap.abilitymodal.close',
    defaultMessage: 'Close',
  },
  reprove: {
    id: 'simulated.contentmap.abilitymodal.reprove',
    defaultMessage: 'Reprove',
  },
  unitsName: {
    id: 'simulated.contentmap.abilitymodal.unitsName',
    defaultMessage: 'SM books Unit name',
  },
  chapterName: {
    id: 'simulated.contentmap.abilitymodal.chapterName',
    defaultMessage: 'SM books chapter name',
  },
  description: {
    id: 'simulated.contentmap.abilitymodal.description',
    defaultMessage: 'Description',
  },
  comments: {
    id: 'simulated.contentmap.abilitymodal.comments',
    defaultMessage: 'Comments',
  },
  officialAbility: {
    id: 'simulated.contentmap.abilitymodal.officialAbility',
    defaultMessage: 'Official ability',
  },
  descriptionOfficialAbility: {
    id: 'simulated.contentmap.abilitymodal.descriptionOfficialAbility',
    defaultMessage: 'Description',
  },
  cancel: {
    id: 'simulated.contentmap.abilitymodal.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'simulated.contentmap.abilitymodal.continue',
    defaultMessage: 'Continue',
  },
  application: {
    id: 'simulated.contentmap.abilitymodal.application',
    defaultMessage: 'Application',
  },
  yearClass: {
    id: 'simulated.contentmap.abilitymodal.class',
    defaultMessage: 'Year/Class',
  },
  curricularComponent: {
    id: 'simulated.contentmap.abilitymodal.curricularComponent',
    defaultMessage: 'Curricular Component',
  },
  unit: {
    id: 'simulated.contentmap.abilitymodal.unit',
    defaultMessage: 'Unit',
  },
  theme: {
    id: 'simulated.contentmap.abilitymodal.theme',
    defaultMessage: 'Theme',
  },
  field: {
    id: 'simulated.contentmap.abilitymodal.field',
    defaultMessage: 'Field',
  },
  content: {
    id: 'simulated.contentmap.abilitymodal.content',
    defaultMessage: 'Content',
  },
  abilitySelected: {
    id: 'simulated.contentmap.abilitymodal.abilitySelected',
    defaultMessage: 'Ability selected',
  },
  indicatorInstituteAbility: {
    id: 'simulated.contentmap.abilitymodal.indicatorInstituteAbility',
    defaultMessage: 'Indicator/Institute ability',
  },
  commentsHelperText: {
    id: 'simulated.contentmap.abilitymodal.commentsHelperText',
    defaultMessage: 'Describe in this field in a very specific observation',
  },
  noOptions: {
    id: 'simulated.contentmap.abilitymodal.noOptions',
    defaultMessage: 'No options',
  },
  createNew: {
    id: 'simulated.contentmap.abilitymodal.createNew',
    defaultMessage: 'Create new',
  },
  loading: {
    id: 'simulated.contentmap.abilitymodal.loading',
    defaultMessage: 'Loading',
  },
});
